<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="d-flex align-center">
        <div>{{ section.name }} # {{ section.displayOrder }} <span v-if="section.role"> - {{ section.role }}</span></div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click.stop="$emit('edit-section')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          small
          color="error"
          class="ml-2"
          @click.stop="$emit('delete-section')"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div class="mb-4 text-sm">{{ section.description }}</div>

      <!-- Fields -->
      <field-list
        :fields="section.fields"
        @edit-field="field => $emit('edit-field', field)"
      />

      <v-btn
        color="primary"
        text
        class="mt-4"
        @click="$emit('add-field')"
      >
        <v-icon left>mdi-plus</v-icon>
        Add Field
      </v-btn>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import FieldList from '../fields/FieldList.vue';

export default {
  name: 'SectionItem',
  components: {
    FieldList
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>
